<template>
  <div :style="{backgroundColor: filterMainPanelBackgroundColor}" >

    <div class="d-flex flex-wrap align-items-end justify-content-end gap-2" style="padding:8px;border-bottom: 1px solid #dee2e6;">
      <div class="d-flex align-items-end gap-2">
        <slot name="filter-left-panel"></slot>
      </div>
      <div class="d-flex align-items-end gap-2 ms-auto flex-wrap justify-content-end">
      <button class="btn btn-light btn-sm border shadow-sm d-flex align-items-end gap-2" @click="toggleFilterSection">
        <i class="fas fa-filter text-secondary"></i>
        <span class="fw-semibold">{{ isSectionOpen ? hideFiltersLabelText : showFiltersLabelText }}</span>
        <i class="fas ms-1 small" :class="isSectionOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>
      <slot name="filter-additional-buttons"></slot>
      </div>
    </div>

    <transition name="slide-fade">
      <div v-show="isSectionOpen" class="card border-0 shadow-sm bg-light" style="margin-bottom: unset!important;">
        <div class="card-body p-3">
          <div v-if="isLoadingFilters" class="d-flex flex-column align-items-center justify-content-center p-2 text-muted">
            <div class="spinner-border text-primary mb-2" role="status" style="width: 2rem; height: 2rem;">
              <span class="visually-hidden">Loading...</span>
            </div>
            <span class="small fw-semibold">Pobieranie ustawień filtrów...</span>
          </div>
          <div v-else class="d-flex align-items-end gap-3">


            <!-- LEWA STRONA: filtry -->
            <div class="d-flex flex-wrap gap-4 align-items-start flex-grow-1">
              <div v-for="(groupName, index) in distinctGroupNames" :key="index" class="filter-group-wrapper">

              <div class="d-flex flex-wrap gap-2 align-items-center">
                  <span class="text-uppercase text-muted fw-bold small border-bottom">
                    {{ groupName }}:
                  </span>

                  <div
                      v-for="(filter, fIndex) in filters.filter(f => f.groupName === groupName)"
                      :key="filter.key + '_' + filtersReloadKey"
                      class="position-relative"
                  >
                    <CommonTableFilter2
                        v-if="filter.groupName === groupName"
                        :filter="filter"
                        :id="'filter_' + fIndex"
                        @onSelectedValues="updateFilters"
                        :filtersFetchMethod="filtersFetchMethod"
                        :filtersFetchParams="filtersFetchParams"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- PRAWA STRONA: przyciski -->
            <div class="d-flex gap-2 flex-shrink-0 align-items-end">
              <button class="btn btn-sm btn-light border shadow-sm text-nowrap" @click="clearFilters">
                <i class="fas fa-eraser text-secondary"></i> Wyczyść filtry
              </button>
              <slot name="applyButton"></slot>
            </div>


          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CommonTableFilter2 from "./CommonTableFilter2.vue";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";

export default {
  name: "CommonTableFilterSection2",
  components: {
    CommonTableFilter2,
  },
  props: {
    filtersFetchMethod: {
      type: Function,
      required: true,
    },
    filtersFetchParams: {
      type: Object,
      required: false,
    },
    explicitFilters: {
      type: Array,
      required: false,
    },
    showFiltersLabelText:{
      type:String,
      default: ()=>{return "Pokaż filtry"}
    },
    hideFiltersLabelText:{
      type:String,
      default: ()=>{return "Ukryj filtry"}
    },
    filterMainPanelBackgroundColor:{
      type:String,
      default: ()=>{return "#ffffff"}
    },
    filtersSet:{
      type:Array,
      required:false,
      default:()=>{return []}
    }
  },
  emits: ['onSelectedFilters'],
  data() {
    return {
      isSectionOpen: false,
      filters: [],
      selectedFilters: [],
      distinctGroupNames: [],
      filtersReloadKey: 0,
      isLoadingFilters: false,
      tempCounter:0,
      emitSelectedFiltersTimeout: null,
    };
  },
  methods: {
    clearFilters() {
      this.selectedFilters = [];
      this.$emit("onSelectedFilters", this.selectedFilters);
      this.fetchFilters();
      // this.filtersReloadKey++;
    },
    toggleFilterSection() {
      this.isSectionOpen = !this.isSectionOpen;
    },
    updateFilters(filterDto) {
      // if selectedFilters contains filterDtoKey then remove it and add again with new values
      this.addSelectedFilter(filterDto);

      if (this.emitSelectedFiltersTimeout) {
        clearTimeout(this.emitSelectedFiltersTimeout);
      }

      this.emitSelectedFiltersTimeout = setTimeout(() => {
        this.$emit("onSelectedFilters", [...this.selectedFilters]);
      }, 50);
    },

    addSelectedFilter(filterDto) {
      let filterDtoKey = filterDto.key;
      let index = this.selectedFilters.findIndex(filter => filter.key === filterDtoKey);
      if (index !== -1) {
        this.selectedFilters.splice(index, 1);
      }
      this.selectedFilters.push(filterDto);
    },
    fetchFilters(){
      const params = this.filtersFetchParams || {};

      // 1. Ustawienie flagi ładowania na start
      this.isLoadingFilters = true;

      this.filtersFetchMethod(params).then((response) => {
        if (response.status === 200) {

          this.filters = JSON.parse(JSON.stringify(response.data.payload)); //FilterOption
          // group filters by groupName alphabetically
          console.log("this.filters::",this.filters);
          this.filters = this.filters.sort((a, b) => a.groupName.localeCompare(b.groupName));
          if(this.explicitFilters){
            this.filters = this.filters.filter(filter => this.explicitFilters.includes(filter.key));
          }
          // console.log("this.filters[i].key::",this.filtersSet);
          if(this.filtersSet && this.filtersSet.length > 0){
            for (let i = 0; i < this.filters.length; i++) {
              const found = this.filtersSet.find(filter => filter.key === this.filters[i].key);
              if(found){
                console.log("Filter found:",found);
                this.filters[i].selectedValues = found.selectedValues; // FilterOption + selectedValues (of filtersSet List<SelectedArrayFilterDto>)
                this.filters[i].allSelected = found.allSelected;
                this.filters[i].excludedValues = found.excludedValues;
              }
            }
          }

          //get distinct group names and sort alphabetically
          this.distinctGroupNames = [...new Set(this.filters.map(filter => filter.groupName))];
          this.distinctGroupNames = this.distinctGroupNames.sort();
        }
        return apiRequestsHelper.handleResponseWithDialogs(response, false);
      }).catch((error) => {
        return apiRequestsHelper.catchResponseError(error,"" + this.filtersFetchMethod);
      }).finally(() => {
        // 2. Wyłączenie flagi ładowania niezależnie od wyniku (sukces/błąd) - Clean Code
        this.isLoadingFilters = false;
      });
    }
  },
  watch: {
    isSectionOpen: {
      handler(newVal) {
        if(newVal === true){
          this.fetchFilters();
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeUnmount() {
    if (this.emitSelectedFiltersTimeout) {
      clearTimeout(this.emitSelectedFiltersTimeout);
    }
  },
  created() {

  }
};
</script>

<style scoped>
/* Bootstrap-like transitions */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Specific responsiveness */
@media (max-width: 768px) {
  .filter-group-wrapper {
    width: 100%;
    margin-bottom: 1rem;
  }
}
</style>